<template>
    <div>
        <b-modal id="modal-bulk-division-update" no-close-on-esc centered no-close-on-backdrop hide-footer
            :body-class="'pt-3'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('bulkDivisionUpdate.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-left">
                <b-form-group :label="$t('bulkDivisionUpdate.divisionLabel')">
                    <v-select class="f-12" :clearable="false" :options="allDivisions" v-model="division"
                        :reduce="(option) => option.id" />
                    <p v-if="errors && errors.division" class="field-error">
                        {{ errors.division[0] }}
                    </p>
                </b-form-group>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('bulkDivisionUpdate.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="bulkUpdateDocs">{{ $t('bulkDivisionUpdate.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "BulkDivisionUpdate",
    props: ["ids", "type"],
    components:{vSelect},
    data() {
        return {
            division: "",
            errors: {}
        }
    },
    computed: {
        ...mapGetters(["divisions"]),
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    methods: {
        ...mapActions(['updateBulkDrivers', 'updateBulkEquipments', "setLoader", "setNotification"]),
        resetPopup() {
            this.division = ""
            this.errors = {}
            this.$bvModal.hide('modal-bulk-division-update')
            this.$emit('close')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === null) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async bulkUpdateDocs() {
            try {
                const nullKeys = this.checkNullValues({
                    division: this.division
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                     if(this.type === 'driver'){
                        await this.updateBulkDrivers({
                            "ids": this.ids,
                            "division": this.division
                        })
                     }
                     else {
                        await this.updateBulkEquipments({
                            "ids": this.ids,
                            "division": this.division
                        })
                     }
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('bulkDivisionUpdate.divisionAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("updateDivision")
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('bulkDivisionUpdate.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }

    },
}
</script>